module.exports = __webpack_public_path__ + "static/img/2222.34467c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/2222.png
// module id = rCR4
// module chunks = 0